let CallBackFn = null;
let DownScrollLoad = {
  add(callback) {
    console.log('---挂载了滚动监听')
    CallBackFn = callback
    window.addEventListener('scroll', this.Scrollbottom);
  },
  remove() {
    console.log('---卸载了滚动监听')
    window.removeEventListener('scroll', this.Scrollbottom)
  },
  // 页面滚动监听事件
  Scrollbottom() {
    if ( window.pageYOffset + window.innerHeight >= parseFloat( document.documentElement.scrollHeight ) - 10  ) {
      console.log(window.pageYOffset , window.innerHeight , document.documentElement.scrollHeight,'---触发滚动到底')
      if(typeof CallBackFn == 'function' ){
        CallBackFn(window.pageYOffset)
      }
    }
  },
}
export default DownScrollLoad;